/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Ref_IntroInputs */

const en_to_yaml_ref_intro = /** @type {(inputs: To_Yaml_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each row is a real JSON value and the exact YAML this tool emits for it.`)
};

const ko_to_yaml_ref_intro = /** @type {(inputs: To_Yaml_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`각 행은 실제 JSON 값과 이 도구가 그것에 대해 내놓는 정확한 YAML입니다.`)
};

const ja_to_yaml_ref_intro = /** @type {(inputs: To_Yaml_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各行は実際の JSON の値と、このツールがそれに対して出す正確な YAML です。`)
};

/**
* | output |
* | --- |
* | "Each row is a real JSON value and the exact YAML this tool emits for it." |
*
* @param {To_Yaml_Ref_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_ref_intro = /** @type {((inputs?: To_Yaml_Ref_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Ref_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_ref_intro(inputs)
	if (locale === "ko") return ko_to_yaml_ref_intro(inputs)
	return ja_to_yaml_ref_intro(inputs)
});